export default ({ phone, clock }) => [
  {
    title: 'Дополнительный </br>текст, телефон', value: phone.order, parentName: 'phone',
  },
  {
    title: 'Дата, время', value: clock.order, parentName: 'clock',
  },
];
